export const EventNames = {
  AchievementUnlocked: 'achievement_unlocked',
  AddPaymentInformation: 'add_payment_information',
  AddShippingInformation: 'add_shipping_information',
  AddToCart: 'add_to_cart',
  AddToWishlist: 'add_to_wishlist',
  AdView: 'ad_view',
  BookTravel: 'book_travel',
  Checkout: 'checkout',
  CustomerApplication: 'customer_application',
  CustomerApplicationFailed: 'customer_application_failed',
  CustomerApplicationSuccessful: 'customer_application_successful',
  CustomerDisqualification: 'customer_disqualification',
  CustomerQualification: 'customer_qualification',
  CustomerRepresentativeContact: 'customer_representative_contact',
  EarnVirtualCurrency: 'earn_virtual_currency',
  Error: 'app_error',
  Invite: 'invite',
  JoinGroup: 'join_group',
  LevelEnd: 'level_end',
  LevelReached: 'level_reached',
  LevelStart: 'level_start',
  LevelUp: 'level_up',
  ListView: 'list_view',
  Login: 'login',
  Logout: 'logout',
  OpenedFromNotification: 'opened_from_notification',
  PostScore: 'post_score',
  Purchase: 'purchase',
  Rate: 'rate',
  ReEngage: 're_engage',
  Refund: 'refund',
  Register: 'register',
  RemoveFromCart: 'remove_from_cart',
  Search: 'search',
  SelectContent: 'select_content',
  SelectItem: 'select_item',
  SelectPromotion: 'select_promotion',
  Share: 'share',
  SpendVirtualCurrency: 'spend_virtual_currency',
  StartTrial: 'start_trial',
  Subscribe: 'subscribe',
  TutorialComplete: 'tutorial_complete',
  TutorialStart: 'tutorial_start',
  ViewCart: 'view_cart',
  ViewItem: 'view_item',
  ViewPromotion: 'view_promotion',

  // The following events are captured automatically by Firebase when on web, native, or both.
  // For more information see https://support.google.com/analytics/answer/9234069?sjid=11265465951830609737-EU
  ActionInAppMessage: 'action_in_app_message',
  AdClick: 'ad_click',
  AdExposure: 'ad_exposure',
  AdImpression: 'ad_impression',
  AdRequest: 'ad_request',
  AdReward: 'ad_reward',
  AdUnitExposure: 'ad_unit_visible',
  AppStorePurchase: 'app_store_purchase',
  AppStoreRefund: 'app_store_refund',
  CampaignLaunch: 'campaign_launch',
  ClearData: 'clear_data',
  DismissInAppMessage: 'dismiss_in_app_message',
  DynamicLinkFirstOpen: 'dynamic_link_first_open',
  DynamicLinkOpen: 'dynamic_link_open',
  DynamicLinkUpdate: 'dynamic_link_update',
  Exception: 'exception',
  ExternalLinkClick: 'external_link_click',
  FileDownload: 'file_download',
  FirstLaunch: 'first_launch',
  FormEdit: 'form_edit',
  FormSubmit: 'form_submit',
  InvalidEvent: 'invalid_event',
  NotificationBackground: 'notification_background',
  NotificationDismiss: 'notification_dismiss',
  NotificationForeground: 'notification_foreground',
  NotificationOpen: 'notification_open',
  OSUpdate: 'os_update',
  ScreenView: 'screen_view',
  Scroll: 'scroll',
  SessionStart: 'session_start',
  SiteSearch: 'site_search',
  SubscriptionCancel: 'subscription_cancel',
  SubscriptionConvert: 'subscription_converted',
  SubscriptionRenew: 'subscription_renew',
  Uninstall: 'uninstall',
  Update: 'update',
  UserEngagement: 'user_engagement',
  VideoComplete: 'video_complete',
  VideoProgress: 'video_progress',
  VideoStart: 'video_start',
  ViewInAppMessage: 'view_in_app_message',
  Visit: 'visit',
};

export const EventParameters = {
  AchievementId: 'achievement_id',
  AdExposureTime: 'ad_exposure_time',
  AdFormat: 'ad_format',
  AdId: 'ad_id',
  AdPlatform: 'ad_platform',
  AdSource: 'ad_source',
  AdType: 'ad_type',
  AdUnitCode: 'ad_unit_code',
  AdUnitId: 'ad_unit_id',
  AdUnitName: 'ad_unit_name',
  AdvertiserUserRelevance: 'advertiser_user_relevance',
  AppVersion: 'app_version',
  ArrivalDate: 'arrival_date',
  Campaign: 'campaign',
  CampaignAnid: 'campaign_anid',
  CampaignClickId: 'campaign_click_id',
  CampaignContent: 'campaign_content',
  CampaignDetailsContent: 'campaign-details-content',
  CampaignDetailsSource: 'campaign_details_source',
  CampaignDetailsTerm: 'campaign_details_term',
  CampaignInformationSource: 'campaign_information_source',
  CampaignMedium: 'campaign_medium',
  CampaignSource: 'campaign_source',
  CampaignTerm: 'campaign_term',
  CancellationReason: 'cancellation_reason',
  CheckInDate: 'check_in_date',
  CheckoutDate: 'checkout_date',
  City: 'city',
  ClickTimestamp: 'click_timestamp',
  ClientId: 'client_id',
  ContentGroup: 'content_group',
  ContentId: 'content_id',
  ContentIds: 'content_ids',
  ContentTitle: 'content_title',
  ContentType: 'content_type',
  Country: 'country',
  Coupon: 'coupon',
  CreativeName: 'creative_name',
  CreativeSlotName: 'creative_slot_name',
  CurrencyCode: 'currency_code',
  CustomCampaignParameter: 'custom_campaign_parameter',
  Date: 'date',
  DeferredAnalyticsCollection: 'deferred_analytics_collection',
  DepartureDate: 'departure_date',
  Description: 'description',
  Destinations: 'destinations',
  DiscountAmount: 'discount_amount',
  DynamicLinkAcceptanceTime: 'dynamic_link_acceptance_time',
  EngagementTime: 'engagement_time',
  ErrorMessage: 'error_message',
  EventEnd: 'event_end',
  EventStart: 'event_start',
  FileExtension: 'file_extension',
  FileLinkText: 'link_text',
  FileName: 'file_name',
  FirstDestination: 'first_destination',
  FirstOpenCount: 'first_open_count',
  FirstOpenWithAnalytics: 'first_open_with_analytics',
  FlightTravelClass: 'flight_travel_class',
  FormId: 'form_id',
  FormName: 'form_name',
  FormSubmissionLink: 'form_submission_link',
  FormSubmitText: 'form_submit_text',
  GameCharacterLevel: 'game_character_level',
  GameCharacterName: 'game_character_name',
  GameLevelName: 'game_level_name',
  GameScore: 'game_score',
  GoogleClickId: 'google_click',
  GroupId: 'group_id',
  HotelReviewScore: 'hotel_review_score',
  IgnoreReferrer: 'ignore_referrer',
  Index: 'index',
  IntroductoryPrice: 'introductory_price',
  IsEmbeddedVideoVisible: 'is_embedded_video_visible',
  IsFatalError: 'is_fatal',
  IsFreeTrial: 'is_free_trial',
  IsOutboundLink: 'is_outbound_link',
  IsSubscriptionPurchase: 'is_subscription_purchase',
  IsSystemAppOpen: 'is_system_app_open',
  IsSystemAppUpdate: 'is_system_app_update',
  ItemBrand: 'item_brand',
  ItemCategory: 'item_category',
  ItemId: 'item_id',
  ItemListId: 'item_list_id',
  ItemListName: 'item_list_name',
  ItemLocationId: 'item_location_id',
  ItemName: 'item_name',
  ItemSubCategoryFour: 'item_subcategory_four',
  ItemSubCategoryOne: 'item_subcategory_one',
  ItemSubCategoryThree: 'item_subcategory_three',
  ItemSubCategoryTwo: 'item_subcategory_two',
  ItemVariant: 'item_variant',
  Level: 'level',
  LinkClasses: 'link_classes',
  LinkDomain: 'link_domain',
  LinkId: 'link_id',
  LinkUrl: 'link_url',
  MaxReviewScore: 'max_review_score',
  Medium: 'medium',
  MessageDeliveryTimestamp: 'message_delivery_time',
  MessageId: 'message_id',
  MessageTimestamp: 'message_time',
  MessageTitle: 'message_name',
  MessageType: 'message_type',
  NavigationSource: 'navigation_source',
  NotificationChannel: 'notification_channel',
  NotificationLabel: 'notification_label',
  NotificationTopic: 'notification_topic',
  OrganizationId: 'organization_id',
  NumberOfAdults: 'number_of_adults',
  NumberOfChildren: 'number_of_children',
  NumberOfInfants: 'number_of_infants',
  PageLocation: 'page_location',
  PageTitle: 'page_title',
  PaymentInformationAvailable: 'payment_information_available',
  PercentScrolled: 'percent_scrolled',
  PreferredNeighborhoods: 'preferred_neighborhoods',
  PreferredNumberOfStops: 'preferred_number_of_stops',
  PreferredPriceRange: 'preferred_price_range',
  PreferredReviewScore: 'preferred_review_score',
  PreviousAppVersion: 'previous_app_version',
  PreviousGMPAppId: 'previous_gmp_app_id',
  PreviousOsVersion: 'previous_os_version',
  PreviousLink: 'previous_link',
  Price: 'price',
  ProductAffiliation: 'product_affiliation',
  ProductId: 'product_id',
  ProjectedRevenue: 'projected_revenue',
  PromotionId: 'promotion_id',
  PromotionName: 'promotion_name',
  PurchaseCurrency: 'purchase_currency',
  Quantity: 'quantity',
  ReceiptId: 'receipt_id',
  Region: 'region',
  RegistrationMethod: 'registration_method',
  ResetAnalyticsCause: 'reset_analytics_cause',
  ReturnTripEnd: 'return_journey_end',
  ReturnTripStart: 'return_journey_start',
  Revenue: 'revenue',
  ReviewScore: 'review_score',
  RewardType: 'reward_type',
  RewardValue: 'reward_value',
  ScreenName: 'screen_name',
  ScreenResolution: 'screen_resolution',
  SearchTerm: 'search_term',
  SecondDestination: 'second_destination',
  SessionId: 'session_id',
  SessionNumber: 'session_number',
  ShippingCost: 'shipping_cost',
  ShippingTier: 'shipping_tier',
  SubscriptionId: 'subscription_id',
  Success: 'success',
  SuggestedDestinations: 'suggested_destinations',
  SuggestedHotels: 'suggested_hotels',
  TaxAmount: 'tax_amount',
  Timestamp: 'timestamp',
  TrafficType: 'traffic_type',
  TransactionId: 'transaction_id',
  TripEnd: 'trip_end',
  TripStart: 'trip_start',
  UserId: 'user_id',
  UserScore: 'user_score',
  Validated: 'validated',
  Value: 'value',
  VideoCurrentTime: 'video_current_time',
  VideoDuration: 'video_duration',
  VideoPercent: 'video_percent',
  VideoProvider: 'video_provider',
  VideoTitle: 'video_title',
  VideoLink: 'video_link',
  VirtualCurrencyName: 'virtual_currency_name',
};